<template>
    <rkm-overlay>
        <rkm-layout-body :title="id ? 'Edição da solicitação' : 'Nova solicitação'">
            <template v-slot:actions>
                <rkm-button
                    @click="goToBack"
                    color="danger"
                >
                    Sair
                </rkm-button>
                <rkm-button
                    @click="$refs.Form.saveExit()"
                    authorize="store-regulacao-solicitacao"
                    color="primary"
                >
                    Salvar e sair
                </rkm-button>
                <rkm-button
                    :disabled="isDisabled"
                    @click="$refs.Form.saveContinue()"
                    authorize="store-regulacao-solicitacao"
                    color="primary"
                >
                    Salvar e continuar
                </rkm-button>
            </template>

            <rkm-layout-content>
                <formSolicitacao
                    :id="this.id"
                    :pacienteId="this.pacienteId"
                    @saveContinue="handleSaveContinue"
                    @saveExit="handleSaveExit"
                    ref="Form"
                />
            </rkm-layout-content>
        </rkm-layout-body>

    </rkm-overlay>
</template>

<script>

// Components.
import formSolicitacao from '@/components/regulacao/solicitacao/Form'

// Vuex.
import { mapActions } from 'vuex'

export default {
    components: { formSolicitacao },
    computed: {
        isDisabled() {
            return this.id !== null;
        }
    },
    methods: {
        ...mapActions(['setShowExitFormConfirmation', 'unsetShowExitFormConfirmation']),
        exit() {

            this.$router.push({ name: 'regulacao-solicitacao-index' })
        },
        goToBack() {

            this.setShowExitFormConfirmation()
            this.$router.push({ name: 'regulacao-solicitacao-index' })
        },
        handleSaveExit() {

            this.unsetShowExitFormConfirmation()
            this.redirectToList()
        },
        handleSaveContinue() {

            this.showSaveNotification();
        },
        redirectToList() {

            this.$router.push({ name: 'regulacao-solicitacao-index' })
        }
    },
    props: {
        id: { type: Number, default: null },
        pacienteId: { type: Number, default: null, required: true },
    },
}
</script>